export default {"src":"/_next/static/media/intr.334bb513.svg","height":51,"width":64,"blurWidth":0,"blurHeight":0};